<script>
import i18n from "@/plugins/i18n";
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            inputLengths: {
              short: 100,
              medium: 1000,
              long: 5000
            },
            
            headers:  [
                {
                    align: "center",
                    value: "No",
                    flex: .03
                },
                {
                    align: "left",
                    value: i18n.t('companyMetrics.assign_modal.fields.description'),
                    flex: .47
                },
                {
                    align: "center",
                    value: i18n.t('companyMetrics.assign_modal.value'),
                    flex: .2
                },
                {
                    align: "center",
                    value: i18n.t('companyMetrics.assign_update_modal.fields.current'),
                    flex: .2
                },
                {
                    align: "center",
                    value: i18n.t('companyMetrics.assign_update_modal.buttons.delete'),
                    flex: .1
                }
            ],

            loading: false,


            selectedTarget: null,

            assignedTargetValue: 0,

            commonTargetName: "", // target name for both selected default and created target //
            commonTargetID: "", // target id for both selected default and created target //

            createdTargetDescription: "",

            defaultTargets: [],
            companyTargets: [],
            assignedTargets: [],

            assignTargetsModal: false,
            assignTargetsStep: 1,

            // assigned target update //

            assignedTargetUpdateModal: false,

            selectedAssignedTarget: null,
            
            updateAssignedTargetValue: null,
            updateAssignedTargetCurrentValue: null,

            // assigned target delete //

            assignedTargetDeleteModal: false,


            // revert functionality //

            pastInputValues: [],
            pastTargetValues: [],
            updateCounter: 0
        }
    },

    mounted() {
        this._getAssignedTargetsByAssignee();
        this._getAllDynamicTargetsByCompanyID();
    },

    methods: {
        ...mapActions("supplier", [
            "getAllDynamicTargetsByCompanyID",
            "getDynamicTargetsByCompanyID",
            "createDynamicTarget",
            "updateDynamicTarget",
            "deleteDynamicTarget",
            "createAssignedTarget",
            "updateAssignedTarget",
            "deleteAssignedTarget",
            "getAssignedTargetsByAssignee"
        ]),

        _getAssignedTargetsByAssignee() { // get the assigned targets of the current company //
            const params = {
                assignee_company_id: this.$user.company_id,
                is_deleted: false
            }
            this.getAssignedTargetsByAssignee(params)
                .then( res => {
                    this.assignedTargets = res.data.assigned_targets;

                    res.data.assigned_targets.forEach( item => {
                        this.pastInputValues.push(
                            {
                                assigned_target_id: item.assigned_target_id,
                                dynamic_target_id: item.dynamic_target_id,
                                input_value: item.input_value,
                                count: this.updateCounter
                            }
                        );

                        this.pastTargetValues.push(
                            {
                                assigned_target_id: item.assigned_target_id,
                                dynamic_target_id: item.dynamic_target_id,
                                target_value: item.target_value,
                                count: this.updateCounter
                            }
                        );
                    });
                })
                .catch(({ response }) => {
                    this.$toast.open({
                      message: this.$parseResMessage(response.data.messageName),
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .finally(() => {
                    this.assignedTargets.forEach( item => {
                        if (item.input_value == null) {
                            item.input_value = 0;
                        }
                    })
                })
        },

        _getAllDynamicTargetsByCompanyID() {
            const params = {
                company_id: parseInt(this.$user.company_id),
                is_deleted: false
            };

            this.getAllDynamicTargetsByCompanyID(params)
                .then(res => {
                    this.loading = true;

                    if (this.assignedTargets.length > 0 ) {
                        this.defaultTargets = res.data.filter( item => { // remove the element from default targets if it is already included //
                            const isAlreadyIncluded = this.assignedTargets.some(element => element.dynamic_target_id === item.dynamic_target_id);
                            return !isAlreadyIncluded;
                        });
                    } else {
                        this.defaultTargets = res.data;
                    }
                })
                .catch(({ response }) => {
                    this.$toast.open({
                      message: this.$parseResMessage(response.data.messageName),
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        _createDynamicTarget() {
            const params = {
                dynamic_target_name: this.commonTargetName,
                description: this.createdTargetDescription ? this.createdTargetDescription : "description",
                reference_target_id: null,
                is_default: false,
                company_id: this.$user.company_id,
                created_by: this.$user.user_id
            };

            this.createDynamicTarget(params)
                .then( res => {
                    this.commonTargetID = res.data.dynamic_target_id;
                    this.$toast.open({
                      message: this.$parseResMessage(res.data.messageName),
                      type: "success",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .catch(({ response }) => {
                    this.$toast.open({
                      message: this.$parseResMessage(response.data.messageName),
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .finally(() => {
                    this._createAssignedTarget();
                })
        },
        
        _createAssignedTarget() {
            const date = new Date();
            const params = {
                assigner_company_id: this.$user.company_id,
                assignee_company_id: this.$user.company_id,
                dynamic_target_id: this.commonTargetID,
                assigned_date: date,
                deadline: `01.01.${date.getFullYear() + 1}`,
                target_value: this.assignedTargetValue,
                //input_value: inputValue, 
                created_by: this.$user.user_id
            };

            this.createAssignedTarget(params)
                .then( res => {
                    this.$toast.open({
                      message: this.$parseResMessage(res.data.messageName),
                      type: "success",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .catch(({ response }) => {
                    this.$toast.open({
                      message: response.message,
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .finally(() => {
                    this.afterPageUpdate();
                })
        },

        _updateAssignedTarget() {
            const params = {
                assigned_target_id: this.selectedAssignedTarget.assigned_target_id,
                target_value: this.updateAssignedTargetValue,
                input_value: this.updateAssignedTargetCurrentValue, //TODO: will we need this? talk to backend and management
                updated_by: this.$user.user_id
            }; 
            this.updateAssignedTarget(params)
                .then( res => {
                    this.$toast.open({
                      message: this.$parseResMessage(res.data.messageName),
                      type: "success",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .catch(({ response }) => {
                    this.$toast.open({
                      message: response.message,
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .finally(() => {
                    this.afterPageUpdate();
                })
        },

        _updateAssignedTarget_TARGET_VALUE(assignedTarget) {
            const params = {
                assigned_target_id: assignedTarget.assigned_target_id,
                target_value: assignedTarget.target_value,
                updated_by: this.$user.user_id
            }; 
            this.updateAssignedTarget(params)
                .then( res => {
                    this.$toast.open({
                      message: this.$parseResMessage(res.data.messageName),
                      type: "success",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .catch(({ response }) => {
                    this.$toast.open({
                      message: response.message,
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .finally(() => {
                    this.afterPageUpdate();
                })
        },

        _updateAssignedTarget_INPUT_VALUE(assignedTarget) {
            const params = {
                assigned_target_id: assignedTarget.assigned_target_id,
                input_value: assignedTarget.input_value,
                updated_by: this.$user.user_id
            }; 
            this.updateAssignedTarget(params)
                .then( res => {
                    this.$toast.open({
                      message: this.$parseResMessage(res.data.messageName),
                      type: "success",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .catch(({ response }) => {
                    this.$toast.open({
                      message: response.message,
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .finally(() => {
                    this.afterPageUpdate();
                })
        },

        _deleteAssignedTarget() {
            const params = {
                assigned_target_id: this.selectedAssignedTarget.assigned_target_id
            };

            this.deleteAssignedTarget(params)
                .then( res => {
                    this.$toast.open({
                      message: this.$parseResMessage(res.data.messageName),
                      type: "success",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .catch(({ response }) => {
                    this.$toast.open({
                      message: response.message,
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                    });
                })
                .finally(() => {
                    this.afterPageUpdate();
                })
        },

        afterPageUpdate() {
            this._getAllDynamicTargetsByCompanyID();
            this.resetAssignTargetsModal();
            this.resetAssignedTargetUpdateModal();
            this._getAssignedTargetsByAssignee();
            this.updateCountHandler();
        },

        updateCountHandler() {
            this.updateCounter++;

            if (this.updateCounter > 2) {
                this.pastInputValues = this.pastInputValues.filter( item => item.count == this.updateCounter || item.count == this.updateCounter-1);
                this.pastTargetValues = this.pastTargetValues.filter( item => item.count == this.updateCounter || item.count == this.updateCounter-1);
            }
        },

        // assign targets modal //

        selectDefaultTarget(item) {
            this.selectedTarget = item;
            this.commonTargetName = item.dynamic_target_name;
            this.commonTargetID = item.dynamic_target_id;
        },

        openAssignTargetsModal() {
            this.assignTargetsModal = true;
        },
        resetAssignTargetsModal() {
            this.assignTargetsModal = false;
            this.selectedTarget = null;
            this.assignTargetsStep = 1;
        },

        nextStep() {
            this.assignTargetsStep++;
        },
        clickCreateOwn() {
            this.selectedTarget = null;
            this.commonTargetID = "";
            this.commonTargetName = "";
            this.assignTargetsStep+=2;
        },

        // assign target update //

        handleUnfocusUpdate(index, type) {
            if (type === "target_val") {
                this._updateAssignedTarget_TARGET_VALUE(this.assignedTargets[index]);
            } else if (type === "input_val") {
                this._updateAssignedTarget_INPUT_VALUE(this.assignedTargets[index]);
            } else {
                throw new Error("Invalid update type for assigned targets!");
            }
        },

        handleRevert(assignedTarget, type) {
            if (type === 'target_val') {
                const foundAssignedTarget = this.pastTargetValues.find( item => item.assigned_target_id == assignedTarget.assigned_target_id && item.count == (this.updateCounter-1));
                if (foundAssignedTarget) {
                    this._updateAssignedTarget_TARGET_VALUE(foundAssignedTarget);
                    this.$toast.open({
                      message: i18n.t('supplierMetrics.revert_success'),
                      type: "success",
                      duration: 5000,
                      dismissible: true,
                    });
                } else {
                    this.$toast.open({
                      message: i18n.t('supplierMetrics.revert_error'),
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                    });
                }
            } else if (type === 'input_val') {
                const foundAssignedTarget = this.pastInputValues.find( item => item.assigned_target_id == assignedTarget.assigned_target_id && item.count == (this.updateCounter-1));
                if (foundAssignedTarget) {
                    this._updateAssignedTarget_INPUT_VALUE(foundAssignedTarget);
                    this.$toast.open({
                      message: i18n.t('supplierMetrics.revert_success'),
                      type: "success",
                      duration: 5000,
                      dismissible: true,
                    });
                } else {
                    this.$toast.open({
                      message: i18n.t('supplierMetrics.revert_error'),
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                    });
                }
            }
        },

        updateCurrentValue(item) {
            try {
                this.selectedAssignedTarget = item;
                this.updateAssignedTargetCurrentValue = item.target.value;
            } catch (error) {
                throw new Error(`Error updating current value! \n\n ${error}`);
            } finally {
                console.log("update");
            }
        },

        resetAssignedTargetUpdateModal() {
            this.assignedTargetUpdateModal = false;
            this.selectedAssignedTarget = null;
            this.assignedTargetValue = null;
            this.assignedTargetCurrentValue = null;
        },

        openDeleteAssignedTargetModal(item) {
            this.assignedTargetDeleteModal = true;
            this.selectedAssignedTarget = item;
        },

        // validation //

        isInteger(input) {
            return /^-?\d{1,3}(?:.\d{3})*(?:.\d+)?$/.test(input) && parseInt(input) <= 100 && parseInt(input) >= 0;
        },

        // utils //

        addTargetValueToName(name, value) {
            if (name.includes("X%")) {
                return name.replace("X%", value + "%");
            } else {
                return name;
            }
        },

        hasPastInputValue(assignedTarget) {
            const foundAssignedTarget = this.pastInputValues.find( item => item.assigned_target_id == assignedTarget.assigned_target_id && item.count == (this.updateCounter-1));
            if (foundAssignedTarget && foundAssignedTarget.input_value != assignedTarget.input_value && foundAssignedTarget.input_value != null && foundAssignedTarget.count == (this.updateCounter-1)) {
                return true;
            } else {
                return false;
            }
        },
        
        hasPastTargetValue(assignedTarget) {
            const foundAssignedTarget = this.pastTargetValues.find( item => item.assigned_target_id == assignedTarget.assigned_target_id && item.count == (this.updateCounter-1));
            if (foundAssignedTarget && foundAssignedTarget.target_value != assignedTarget.target_value && foundAssignedTarget.target_value != null && foundAssignedTarget.count == (this.updateCounter-1)) {
                return true;
            } else {
                return false;
            }
        },
    }
}
</script>

<template>
    <div class="flex-all-centered-row p-3">
        <div class="loading-container" v-if="loading">
            <b-spinner variant="success"></b-spinner>
        </div>

        <div v-else class="flex-all-centered-row">
            <div class="flex-all-centered-col" v-if="assignedTargets.length > 0">
                <div class="assigned-targets-table">
                    <div class="header-row">
                        <div class="header-cell" v-for="(item, index) in headers" :key="index" :style="{textAlign: item.align, flex: item.flex}">
                            {{ item.value }}
                        </div>
                    </div>
                    <div v-for="(item, index) in assignedTargets" :key="index" class="target-row">
                        <div class="target-cell" :style="{textAlign: headers[0].align, flex: headers[0].flex}" 
                             style="display: flex; flex-direction: row; justify-content: center; align-content: center; align-items: center;"
                        >
                            {{ index+1 }} 
                            <i class="fa-solid fa-circle-info pl-2" style="scale: .9; color: var(--sustainfinity-blue);"
                               v-b-tooltip.hover.bottom="{title: item.description, disabled: (!item.description || item.description == 'description') }"
                            ></i>
                        </div>
                        <div class="target-cell" :style="{textAlign: headers[1].align, flex: headers[1].flex}" >
                            {{ addTargetValueToName(item.dynamic_target_name, item.target_value) }}
                        </div>
                        <div class="target-cell input-cell" :style="{textAlign: headers[2].align, flex: headers[2].flex}" >
                            <input type="number" class="input-suppliers" v-model="assignedTargets[index].target_value" @blur="handleUnfocusUpdate(index, 'target_val')">
                            <i class="fa-solid fa-backward" v-if="hasPastTargetValue(item)" @click="handleRevert(item, 'target_val')" 
                                v-b-tooltip.hover="{title: $t('supplierMetrics.revert_tooltip')}"
                            ></i>
                        </div>
                        <div class="target-cell input-cell" :style="{textAlign: headers[3].align, flex: headers[3].flex}" >
                            <input type="number" class="input-suppliers" v-model="assignedTargets[index].input_value" @blur="handleUnfocusUpdate(index, 'input_val')">
                            <i class="fa-solid fa-backward" v-if="hasPastInputValue(item)" @click="handleRevert(item, 'input_val')" 
                                v-b-tooltip.hover="{title: $t('supplierMetrics.revert_tooltip')}"
                            ></i>
                        </div>
                        <div class="target-cell" :style="{textAlign: headers[4].align, flex: headers[4].flex}" @click="openDeleteAssignedTargetModal(item)">
                            <i class="fa-solid fa-trash"></i>
                        </div>
                    </div>
                </div>


                <div class="target-update-button" @click="openAssignTargetsModal()">
                    <i class="fa-regular fa-plus"></i>
                </div>
            </div>
            <div v-else class="nothing-yet">
                {{ $t('companyMetrics.nothing') }} 
                <br>
                <b-button variant="success" @click="openAssignTargetsModal()"
                    style="box-shadow: 0 0 .5em .1em gray; margin-top: 1em; font-size: .66em;"
                >
                    {{ $t('companyMetrics.click_here') }}
                </b-button>
            </div>
        </div>



        <b-modal
            v-model="assignTargetsModal"
            size="xl" centered no-close-on-backdrop hide-footer
            :title="$t('companyMetrics.assign_modal.title')"
            @hidden="resetAssignTargetsModal()"
        >
            <div class="flex-all-centered-row default-targets-container" v-if="assignTargetsStep === 1">
                <div v-for="(item, index) in defaultTargets" :key="index" @click="selectDefaultTarget(item)"
                    class="default-target" :class="{'selected-default-target': selectedTarget ? item.dynamic_target_id == selectedTarget.dynamic_target_id : false}"
                >
                    {{ item.dynamic_target_name }}
                </div>
                <div class="flex-all-centered-row" style="justify-content: space-between;">
                    <div class="create-dynamic-target" @click="clickCreateOwn()">
                        {{ $t('companyMetrics.assign_modal.find') }} <span>{{ $t('companyMetrics.assign_modal.add') }}</span>
                    </div>
                    <b-button @click="nextStep()" variant="success" :disabled="selectedTarget == null">
                        {{ $t('companyMetrics.assign_modal.proceed') }}
                    </b-button>
                </div>
            </div>


            <div class="flex-all-centered-col" v-if="assignTargetsStep === 2">
                <div class="flex-all-centered-row">
                    <div style="max-width: 60%; margin-right: 1em; font-weight: bold; font-size: 1.3em;">
                        {{ selectedTarget.dynamic_target_name }}
                    </div>
                    <input type="number" class="input-suppliers" :placeholder="$t('companyMetrics.assign_modal.value')" 
                           style="box-shadow: 0 0 .33em .1em lightgray;"
                           v-model="assignedTargetValue"
                    >
                </div>
                <b-button
                    @click="_createAssignedTarget()"
                    variant="success"
                    :disabled="!isInteger(assignedTargetValue)"
                    style="align-self: flex-end; margin-top: 1em;"
                >
                    {{ $t('companyMetrics.assign_modal.assign') }}
                </b-button>
            </div>


            <div class="flex-all-centered-col" v-if="assignTargetsStep === 3">
                <div class="flex-all-centered-col">
                    <div class="flex-all-centered-row" style="margin-bottom: 1em;">
                        <input style=" margin-right: 1em; font-weight: bold; text-align: right;"
                            v-model="commonTargetName" class="supplier-text-input"
                            :placeholder="$t('companyMetrics.assign_modal.fields.name')"
                            :maxLength="inputLengths.short"
                        >
                        <input type="number" class="input-suppliers" :placeholder="$t('companyMetrics.assign_modal.value')" 
                               style="box-shadow: 0 0 .33em .1em lightgray;"
                               v-model="assignedTargetValue"
                        >
                    </div>
                    <b-form-textarea
                        :placeholder="$t('companyMetrics.assign_modal.fields.description')"
                        rows="3" v-model="createdTargetDescription" :maxLength="inputLengths.long"
                    />
                </div>
                <b-button
                    @click="_createDynamicTarget()"
                    variant="success"
                    :disabled="!isInteger(assignedTargetValue) || !commonTargetName"
                    style="align-self: flex-end; margin-top: 1em;"
                >
                    {{ $t('companyMetrics.assign_modal.create') }}
                </b-button>
            </div>
        </b-modal>

        <b-modal
            v-if="assignedTargetDeleteModal"
            v-model="assignedTargetDeleteModal"
            size="md" centered hide-header
            @ok="_deleteAssignedTarget()"
            @cancel="resetAssignedTargetUpdateModal()"
            @hidden="resetAssignedTargetUpdateModal()"
        >
            <div class="flex-all-centered-col" style="text-align: center;">
                <div class="flex-all-centered-row" style="font-weight: bold; font-size: 1.33em; padding-bottom: .5em; font-style: italic">
                    {{ selectedAssignedTarget.dynamic_target_name }}
                </div>
                <div class="flex-all-centered-row" style="font-size: 1.1em;">
                    {{ $t('companyMetrics.assigned_delete_warning') }}
                </div>
            </div>
            <template #modal-footer="{ok, cancel}">
                <b-button variant="danger" @click="cancel()">{{ $t('companyMetrics.assign_update_modal.buttons.cancel') }}</b-button>
                <b-button variant="success" @click="ok()" >{{ $t('companyMetrics.assign_update_modal.buttons.delete') }}</b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang='scss' scoped>
    

    .default-targets-container {
        flex-wrap: wrap;
        padding: .66em;
        align-items: stretch !important;

        > .default-target {
            font-weight: bold;
            padding: 1em;
            border-radius: .75em;
            border: thin solid var(--sustainfinity-blue);
            
            display: flex;
            align-items: center;
            width: 40%;
            margin: 1em;
            margin-top: .25em;
            margin-bottom: .25em;

            transition: all 100ms;
            cursor: pointer;
            &:hover {
                border: thin solid var(--sustainfinity-green);
                box-shadow: 0 0 .5em .1em var(--sustainfinity-blue) inset;
                background-color: var(--sustainfinity-faded-blue);
            }
        }

        > .selected-default-target {
            color: var(--sustainfinity-blue);
            border: thin solid var(--sustainfinity-green);
            box-shadow: 0 0 .5em .1em var(--sustainfinity-green) inset;
            background-color: var(--sustainfinity-faded-blue);
        }

        > div 
            > .create-dynamic-target {
                margin-top: 1em;
                font-weight: bold;
                font-size: 1.2em;
                text-align: center;
                
                > span {
                    transition: all 100ms;

                    cursor: pointer;
                    &:hover {
                        color: var(--sustainfinity-navy);
                        text-decoration: underline;
                    }
                }
            }
    }

    .nothing-yet {
        font-weight: bold;
        font-size: 1.5em;
        text-align: center;

        > span {
            transition: all 100ms;

            cursor: pointer;
            &:hover {
                color: var(--sustainfinity-navy);
                text-decoration: underline;
            }
        }
    }

    .input-suppliers {
        outline: 0;
        border: thin solid var(--sustainfinity-blue);
        border-radius: .7em;
        padding: .5em;
        padding-top: .75em;
        padding-bottom: .75em;
        font-size: 1.1em;
        text-align: center;
        background: whitesmoke;


        transition: all 100ms;
        &:focus {
            background: 0;
            border: thin solid var(--sustainfinity-green);
        }
    }
    .supplier-text-input {
        outline: 0;
        border: 0;
        border-bottom: .1em solid var(--sustainfinity-navy);
        padding: .15em;
        width: 100%;
        background: 0;
        text-align: left !important;

        transition: all 100ms;
        &:focus {
            border-bottom: .1em solid var(--sustainfinity-blue);
        }
    }

    .target-update-button {
        align-self: flex-start;
        padding: .66em;
        padding-left: 1.5em;
        padding-right: 1.5em;
        border-radius: .66em;
        background-color: #f3bb45;
        color: white;
        font-weight: bold;
        font-size: 1.25em;
        box-shadow: 0 0 .5em .1em gray;

        transition: all 100ms;
        cursor: pointer;
        &:hover {
            filter: brightness(95%);
        }
    }

    .assigned-targets-table {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        width: 100%;

        margin-bottom: 2em;

        filter: drop-shadow(0 0 .66em gray);

        > .header-row {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            align-items: center;
            width: 100%;

            background-color: var(--sustainfinity-navy);
            border-top-left-radius: 1.33em;
            border-top-right-radius: 1.33em;

            color: white;

            > .header-cell {
                padding: .66em;
                border-right: .1em solid white;
                &:last-of-type {
                    border-right: 0 !important;
                }
            }

        }

        > .target-row {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            align-items: center;
            width: 100%;

            background-color: whitesmoke;

            color: black;

            > .target-cell {
                padding: .66em;

                &:last-of-type {
                    display: flex;
                    justify-content: center !important;
                }

                > .fa-trash {
                    color: var(--invalid-input);

                    cursor: pointer;
                    &:hover {
                        filter: brightness(125%);
                    }
                }
            }

            > .input-cell {
                position: relative;

                > i {
                    position: absolute;

                    top: 50%;
                    transform: translateY(-50%);
                    right: 2em;

                    color: var(--sustainfinity-navy);

                    cursor: pointer;

                    transition: all 100ms;
                    &:hover {
                        color: var(--sustainfinity-blue);
                    }
                }
            }

            &:last-of-type {
                border-bottom-left-radius: 1.33em;
                border-bottom-right-radius: 1.33em;
            }

        }
    }
</style>